import { Validators } from '@angular/forms';
import { AccessLevelTypes } from '@app/enums/AccessLevelTypes';
import { MdsOption } from '@medpacesoftwaredevelopment/designsystem';
import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { maxLengthValidator, notWhitespaceValidator } from '@utility/utility.validators';

export const availableAccessLevels: MdsOption<AccessLevelTypes>[] = [
    { value: AccessLevelTypes.Assistant, viewValue: 'Assistant' },
    { value: AccessLevelTypes.Coordinator, viewValue: 'Coordinator' },
    { value: AccessLevelTypes.LeadCoordinator, viewValue: 'Lead Coordinator' },
    { value: AccessLevelTypes.Manager, viewValue: 'Manager' },
];

//used also in create-access-request-dialog.component
export class AccessRequestSSOFormGroup extends PersistentFormGroup<{
    justification: PersistentFormControl<string | null>;
    userAccessGroup: PersistentFormControl<AccessLevelTypes>;
}> {
    constructor() {
        super({
            justification: new PersistentFormControl<string | null>(null, [
                notWhitespaceValidator(),
                maxLengthValidator(500),
            ]),
            userAccessGroup: new PersistentFormControl<AccessLevelTypes>(AccessLevelTypes.Assistant, [
                Validators.required,
            ]),
        });
    }
}
